// import {PWMAT_RESOURCE} from './consts'

export const LongxunRoom = [
{
  name:'Longxun Lecture Series 1',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k/?spm_id_from=333.999.0.0',
  file_name:'Introduction to the principle and application of Charge Patching Method for large system calculation'
},
{
  name:'Longxun Lecture Series 2',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=2',
  file_name:'First-principles calculation of the quantum efficiency and lifetime of point defects in semiconductors'
},
{
  name:'Longxun Lecture Series 3',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=3',
  file_name:'Computing experts talk to us about solar cells'
},
{
  name:'Longxun Lecture Series 4',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=4',
  file_name:'New hotspot in the field of material calculation: non-adiabatic molecular dynamics'
},
{
  name:'Longxun Lecture Series 5',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=5',
  file_name:'Introduction to 2019 Novel Coronavirus and Antiviral Drug Design'
},
{
  name:'Longxun Lecture Series 6',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=6',
  file_name:'Simulation of material ionization damage under electron beam irradiation'
},
{
  name:'Longxun Lecture Series 7',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=7',
  file_name:'Non-equilibrium dynamic effects such as ion bombardment and laser beam irradiation in semiconductors'
},
{
  name:'Longxun Lecture Series 8',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=8',
  file_name:'Computational design of low-dimensional non-metallic catalysts'
},
{
  name:'Longxun Lecture Series 9',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=9',
  file_name:'Dimension-independent semiconductor defect calculation theory'
},
{
  name:'Longxun Lecture Series 10',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=10',
  file_name:'Catalytic veterans show you how to synthesize ammonia'
},
{
  name:'Longxun Lecture Series 11',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=11',
  file_name:'Computation and high-throughput screening of nonlinear optical crystal materials'
},
{
  name:'Longxun Lecture Series 12',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=12',
  file_name:'New photovoltaic materials and surface interface states'
},
{
  name:'Longxun Lecture Series 13',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=13',
  file_name:'HPC+AI+Physical Model: New Development of Intelligent Supercomputing Applications'
},
{
  name:'Longxun Lecture Series 14',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=14',
  file_name:'Application of first principles simulation in lithium battery research'
},
{
  name:'Longxun Lecture Series 16',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=15',
  file_name:'Second-order nonlinear optical properties and exciton response of asymmetric low-dimensional materials'
},
{
  name:'Longxun Lecture Series 17',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=16',
  file_name:'DFT simulation of electronic properties of two-dimensional and three-dimensional moiré superlattices'
},
{
  name:'Longxun Lecture Series 18',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=17',
  file_name:'Application of fixed potential method in electrochemical reaction simulation'
},
]
